import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { BorrowerTemplate } from '~/borrower/domains/page/ui/BorrowerTemplate';
import { AssignmentRouter } from '~/borrower/routes/assignment/Router';
import { BorrowerHomeRoute } from '~/borrower/routes/BorrowerHomeRoute';
import { CreditAgreementsRoute } from '~/borrower/routes/CreditAgreementRoute';
import { InsightsRouter } from '~/borrower/routes/insights/Router';
import { CreditFacilityReceivablesDashboardRouter } from '~/borrower/routes/receivables/CreditFacilityReceivablesDashboardRouter';
import { ReceivableDetailsRoute } from '~/borrower/routes/receivables/ReceivableDetailsRoute';
import { StatementsRouter } from '~/borrower/routes/statements/Router';
import { StratsRoute } from '~/borrower/routes/StratsRoute';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import {
  RouteErrorBoundary,
  RouteErrorBoundaryFallbackFn,
} from '~/contexts/MonitoringProvider';

// Helpers
const defaultRouteErrorFallback: RouteErrorBoundaryFallbackFn = ({
  message,
  showErrorToast,
}) => {
  showErrorToast(message);
  return <Navigate to="/" />;
};

// Exports
export const BorrowerRouter = () => {
  const flags = useFeatureFlags();

  // each route / subrouter below is wrapped in a route template with old dashboard formatting
  // as we work on updating overall dashboard UI, we can incrementally move each route out of the old template one at a time
  return (
    <BorrowerTemplate>
      <Routes>
        <Route path="/" element={<BorrowerHomeRoute />} />
        <Route
          path="/credit-agreements/*"
          element={
            <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
              <CreditAgreementsRoute />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/assignments/*"
          element={
            <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
              <AssignmentRouter />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/strats/*"
          element={
            // !TODO @eldarshamukhamedov Move feature flag logic inside the route component
            flags.productsStratsPermissions === 'allow' ? (
              <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
                <StratsRoute />
              </RouteErrorBoundary>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/insights/*"
          element={
            <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
              <InsightsRouter />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/statements/*"
          element={
            <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
              <StatementsRouter />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/credit-facility-receivables/*"
          element={
            <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
              <CreditFacilityReceivablesDashboardRouter />
            </RouteErrorBoundary>
          }
        />
        {/* !TODO @eldarshamukhamedov All other receivalbles routes are under /credit-facility-receivables, why is this one different? */}
        <Route
          path="/receivables/:finleyReceivableId"
          element={
            <RouteErrorBoundary fallback={defaultRouteErrorFallback}>
              <ReceivableDetailsRoute />
            </RouteErrorBoundary>
          }
        />

        <Route path="/*" element={<Navigate to="/" replace />} />
      </Routes>
    </BorrowerTemplate>
  );
};
